<template>
    <div>
        <v-dialog v-model="openDialog" persistent>

            <v-card>
                <v-card-title>
                {{ formTitle }}
                </v-card-title>
                <v-divider></v-divider>
                <flash-message></flash-message>
                <v-divider></v-divider>
                <v-card-text>
                <v-container>
                <ValidationObserver ref="observer">
                    <form>
                        <v-row>
                            <v-col cols="12" sm="6" md="6">
                              <ValidationProvider v-slot="{ errors }" name="Nome" rules="required|max:50">
                                <v-text-field label="Nome" v-model="frmItem.name"
                                              prepend-icon="mdi-card-text" required :error-messages="errors"></v-text-field>
                              </ValidationProvider>
                            </v-col>
                            <v-col cols="12" sm="6" md="6">
                                <ValidationProvider v-slot="{ errors }" name="Descrição" rules="required|max:255">
                                    <v-text-field label="Descrição" v-model="frmItem.description"
                                    prepend-icon="mdi-card-text" required :error-messages="errors"></v-text-field>
                                </ValidationProvider>
                            </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" sm="6" md="6">
                            <ValidationProvider v-slot="{ errors }" name="Papel" rules="required">
                              <v-select :no-data-text="noDataAvailable" label="Papel" v-model="frmItem.userRole"
                                        :items="allUserRoles" item-text="value" item-value="id"
                                        :error-messages="errors" required>
                              </v-select>
                            </ValidationProvider>
                          </v-col>
                            <v-col cols="6" sm="4" md="2">
                                <header>Padrão</header>
                                <v-switch v-model="frmItem.defaults"></v-switch>
                            </v-col>
                        </v-row>
                    </form>
                </ValidationObserver>
                </v-container>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="buttonTextColor" text @click="close">Cancelar</v-btn>
                    <v-btn color="buttonTextColor" text @click="save">Salvar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import { required, max } from 'vee-validate/dist/rules';
import {
  extend, ValidationObserver, ValidationProvider, setInteractionMode,
} from 'vee-validate';

setInteractionMode('eager');

extend('required', {
  ...required,
  message: '{_field_} não pode ser vazio',
});

extend('max', {
  ...max,
  message: '{_field_} não pode ter mais do que {length} characteres',
});

export default {
  name: 'DialogItem',
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    open: Boolean,
    allUserRoles: Array,
    ruleGroups: Array,
    editedItem: {},
    editing: Boolean,
  },

  data: () => ({
    dialogSearch: false,
    searchDialogSearch: '',
    selectedDialogSearch: [],
    defaultItem: {
      name: '',
      description: '',
      userRole: '',
      defaults: false,
    },
    frmItem: {},
    openDialog: false,
    allProfiles: [],
    searchedUsers: [],
    loadingSearchData: false,
    searchPagination: {
      page: 1,
      rowsPerPage: 5,
      totalItems: 0,
    },
    noDataAvailable: 'Nenhum dado encontrado',
  }),

  computed: {
    formTitle() {
      return !this.editing ? 'Novo grupo' : 'Editar grupo';
    },
  },

  watch: {
    open() {
      this.openDialog = this.open;
    },
    editedItem() {
      this.frmItem = { ...this.editedItem };
    },
  },

  methods: {
    clearRuleConfigs() {
      this.frmItem.ruleConfigs = [];
    },

    close() {
      this.$refs.observer.reset();
      this.$emit('closeDialogItem');
    },

    save() {
      this.$refs.observer.validate().then((result) => {
        if (result) {
          this.$emit('saveDialogItem', this.frmItem);
          this.$refs.observer.reset();
        }
      });
    },

  },
};
</script>
